import { FC } from 'react';

type Props = {
    className?: string;
};

const Coupon01IconSolid: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="#2B2B2B"
            stroke="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0013 18.9581C9.75214 18.9581 9.53897 18.8886 9.34472 18.7984C8.7023 18.4786 7.90902 18.0218 7.31858 17.6714C6.89602 17.4206 6.68474 17.2952 6.45991 17.2933C6.2351 17.2913 6.02575 17.4108 5.60708 17.6496L4.7696 18.1273C4.35025 18.3338 3.64172 18.5972 3.003 18.2099C2.55849 17.9405 2.41139 17.4873 2.35082 17.0775C2.2929 16.6856 2.29293 16.1747 2.29297 15.5859V6.62078C2.29295 5.48112 2.29295 4.56252 2.39008 3.84005C2.49092 3.08995 2.70667 2.4584 3.20827 1.9568C3.70986 1.4552 4.34143 1.23945 5.09151 1.13861C5.81398 1.04148 6.7326 1.04149 7.87224 1.0415H12.1304C13.2701 1.04149 14.1886 1.04148 14.9111 1.13861C15.6612 1.23945 16.2927 1.4552 16.7943 1.9568C17.296 2.4584 17.5117 3.08995 17.6126 3.84005C17.7096 4.56252 17.7096 5.48112 17.7096 6.62078V15.5859C17.7096 16.1747 17.7097 16.6856 17.6518 17.0775C17.5912 17.4873 17.4441 17.9405 16.9996 18.2099C16.3609 18.5972 15.6524 18.3338 15.2331 18.1273L14.3956 17.6496C13.9769 17.4108 13.7676 17.2913 13.5427 17.2933C13.3179 17.2952 13.1066 17.4206 12.6841 17.6714C12.0936 18.0218 11.3003 18.4786 10.6579 18.7984C10.4636 18.8886 10.2505 18.9581 10.0013 18.9581ZM6.91205 12.2558C6.58661 11.9303 6.58661 11.4027 6.91205 11.0773L11.9121 6.07725C12.2375 5.75181 12.7651 5.75181 13.0906 6.07725C13.416 6.40269 13.416 6.93032 13.0906 7.25576L8.09056 12.2558C7.76512 12.5812 7.23749 12.5812 6.91205 12.2558ZM7.50878 5.83317H7.5013C7.04107 5.83317 6.66797 6.20627 6.66797 6.6665C6.66797 7.12675 7.04107 7.49984 7.5013 7.49984H7.50878C7.96901 7.49984 8.34214 7.12675 8.34214 6.6665C8.34214 6.20627 7.96901 5.83317 7.50878 5.83317ZM12.4938 10.8332C12.0336 10.8332 11.6605 11.2063 11.6605 11.6665C11.6605 12.1268 12.0336 12.4998 12.4938 12.4998H12.5013C12.9616 12.4998 13.3346 12.1268 13.3346 11.6665C13.3346 11.2063 12.9616 10.8332 12.5013 10.8332H12.4938Z"
                fill="inherit"
            />
        </svg>
    );
};

export default Coupon01IconSolid;
